export default __webpack_public_path__ + "static/media/skill6.c580b484.svg";